import axios from "axios";

const API_URL =  process.env.REACT_APP_API_URL_PRODUCTION;//process.env.REACT_APP_API_URL

// Instancia pública para operaciones sin autenticación (login, registro, etc.)
export const publicApi = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000,
});

// Factory para crear instancia autenticada
export const createAuthenticatedApi = (token) => {
  const authenticatedApi = axios.create({
    baseURL: API_URL,
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    },
    timeout: 30000,
  });

  // Interceptor para manejo de tokens expirados
  authenticatedApi.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 401) {
        // Disparar evento personalizado para logout automático
        window.dispatchEvent(new CustomEvent('auth:token-expired'));
      }
      return Promise.reject(error);
    }
  );

  return authenticatedApi;
};

// Hook para API autenticada (solo se usa después de la inicialización del contexto)
export const useApi = () => {
  // Importación dinámica para evitar dependencia circular
  const { useAuth } = require("../context/AuthContext");
  const { token } = useAuth();
  
  return createAuthenticatedApi(token);
};